import React from "react";
// React Table
import { Container, Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaJuridicos = ({ datosMisionObra }) => {
  return (
    <Container>
      <Table bordered responsive>
        <tbody>
          <tr >
            <CustomTd className={"w-25"}>
              <span>Propiedad</span>
            </CustomTd>
            <td>{datosMisionObra?.property || <small>No especificado</small>}</td>
          </tr>

          <tr>
            <CustomTd>
              <span>Personalidad jurídica</span>
            </CustomTd>
            <td>{datosMisionObra?.legalForm || <small>No especificado</small>}</td>
          </tr>
        </tbody>
      </Table>
    </Container>
  );
};

export default VistaJuridicos;
